import "./ContactUs.module.css";
import SiteHeader from "@/reusable_sections/Header";
import ContactFormDetails from "./sections/ContactFormDetails";
import MapAndLocation from "./sections/MapAndLocation";
import SiteFooter from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <SiteHeader />
      <ContactFormDetails />
      <MapAndLocation />
      <SiteFooter />
    </div>;
}